import React from "react";



import { Card, Button } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import ArrowBackIos from "@material-ui/icons/ArrowBackIos";

import { useHistory } from "react-router-dom";

import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import { i18n } from "../../translate/i18n";
import { IconChevronLeft } from "../ChatLayout/tailwickChatIcons";



const useStyles = makeStyles((theme) => ({

	ticketHeader: {

		zIndex: 10,

		display: "flex",

		minHeight: "4.5em",



		[theme.breakpoints.down("sm")]: {

			width: "100%",

			alignItems: "center",

			justifyContent: "center",

		},



		[theme.breakpoints.up("md")]: {

			minHeight: "59px",

		},

	},



	arrowBack: {

		marginLeft: "1em",

	},

}));



function TicketHeader({ loading, children, tailwickLayout = false }) {

	const classes = useStyles();

	const history = useHistory();

	const handleBack = () => {

		history.push("/tickets");

	};



	const darkMode = localStorage.getItem("darkMode") === "true";



	if (loading) {
		if (tailwickLayout) {
			return (
				<div className="tailwick-chat-header tailwick-chat-header--conversation card-body">
					<div className="flex animate-pulse items-center gap-2.5">
						<div className="size-9 rounded-full bg-default-200" />
						<div className="space-y-1.5">
							<div className="h-3 w-32 rounded bg-default-200" />
							<div className="h-2 w-24 rounded bg-default-150" />
						</div>
					</div>
				</div>
			);
		}
		return <TicketHeaderSkeleton />;
	}



	if (tailwickLayout) {
		return (
			<div className="tailwick-chat-header tailwick-chat-header--conversation card-body">
				<div className="tailwick-chat-header-inner">
					<button
						type="button"
						className="tailwick-chat-back btn size-8 shrink-0 text-default-600 hover:text-primary lg:hidden"
						onClick={handleBack}
						aria-label={i18n.t("chat.layout.backToList")}
					>
						<IconChevronLeft size={20} />
					</button>
					{children}
				</div>
			</div>
		);
	}



	return (

		<Card

			square

			className={classes.ticketHeader}

			style={{ backgroundColor: darkMode ? "#1b1d1d" : "#ffff" }}

		>

			<Button color="primary" onClick={handleBack}>

				<ArrowBackIos className={classes.arrowBack} />

			</Button>

			{children}

		</Card>

	);

}



export default TicketHeader;

